(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');

    function imageToDataUri(img, width, height, quality) {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        let hRatio = img.height / img.width;
        let vRatio = img.width / img.height;
        let ratio = Math.max(hRatio, vRatio);
        canvas.width = Math.min(img.height, img.width);
        canvas.height = Math.min(img.height, img.width);
        let centerShiftX = (canvas.width - img.width * ratio) / 2;
        let centerShiftY = (canvas.height - img.height * ratio) / 2;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, img.width, img.height,
            centerShiftX, centerShiftY, img.width * ratio, img.height * ratio);
        let newRatio = Math.max(height / img.height, width / img.width);

        if (newRatio < 1) {
            canvas = downScaleCanvas(canvas, newRatio);
        }

        return canvas.toDataURL('image/jpeg', quality);
    }

    function downScaleCanvas(cv, scale) {
        if (scale >= 1 || scale <= 0) throw ('scale must be a positive number <1 ');
        let sqScale = scale * scale; // square scale = area of source pixel within target
        let sw = cv.width; // source image width
        let sh = cv.height; // source image height
        let tw = Math.floor(sw * scale); // target image width
        let th = Math.floor(sh * scale); // target image height
        let sx = 0, sy, sIndex = 0; // source x,y, index within source array
        let tx = 0, ty = 0, yIndex = 0, tIndex = 0; // target x,y, x,y index within target array
        let tX = 0, tY = 0; // rounded tx, ty
        let w = 0, nw = 0, wx = 0, nwx = 0, wy = 0, nwy = 0; // weight / next weight x / y
        // weight is weight of current source point within target.
        // next weight is weight of current source point within next target's point.
        let crossX = false; // does scaled px cross its current px right border ?
        let crossY = false; // does scaled px cross its current px bottom border ?
        let sBuffer = cv.getContext('2d').getImageData(0, 0, sw, sh).data; // source buffer 8 bit rgba
        let tBuffer = new Float32Array(3 * tw * th); // target buffer Float32 rgb
        let sR = 0, sG = 0, sB = 0; // source's current point r,g,b
        /* untested !
        var sA = 0;  //source alpha  */

        for (sy = 0; sy < sh; sy++) {
            ty = sy * scale; // y src position within target
            tY = 0 | ty;     // rounded : target pixel's y
            yIndex = 3 * tY * tw;  // line index within target array
            crossY = (tY !== (0 | ty + scale));
            if (crossY) { // if pixel is crossing botton target pixel
                wy = (tY + 1 - ty); // weight of point within target pixel
                nwy = (ty + scale - tY - 1); // ... within y+1 target pixel
            }
            for (sx = 0; sx < sw; sx++, sIndex += 4) {
                tx = sx * scale; // x src position within target
                tX = 0 | tx;    // rounded : target pixel's x
                tIndex = yIndex + tX * 3; // target pixel index within target array
                crossX = (tX !== (0 | tx + scale));
                if (crossX) { // if pixel is crossing target pixel's right
                    wx = (tX + 1 - tx); // weight of point within target pixel
                    nwx = (tx + scale - tX - 1); // ... within x+1 target pixel
                }
                sR = sBuffer[sIndex];   // retrieving r,g,b for curr src px.
                sG = sBuffer[sIndex + 1];
                sB = sBuffer[sIndex + 2];

                /* !! untested : handling alpha !!
                   sA = sBuffer[sIndex + 3];
                   if (!sA) continue;
                   if (sA != 0xFF) {
                       sR = (sR * sA) >> 8;  // or use /256 instead ??
                       sG = (sG * sA) >> 8;
                       sB = (sB * sA) >> 8;
                   }
                */
                if (!crossX && !crossY) { // pixel does not cross
                    // just add components weighted by squared scale.
                    tBuffer[tIndex] += sR * sqScale;
                    tBuffer[tIndex + 1] += sG * sqScale;
                    tBuffer[tIndex + 2] += sB * sqScale;
                } else if (crossX && !crossY) { // cross on X only
                    w = wx * scale;
                    // add weighted component for current px
                    tBuffer[tIndex] += sR * w;
                    tBuffer[tIndex + 1] += sG * w;
                    tBuffer[tIndex + 2] += sB * w;
                    // add weighted component for next (tX+1) px
                    nw = nwx * scale;
                    tBuffer[tIndex + 3] += sR * nw;
                    tBuffer[tIndex + 4] += sG * nw;
                    tBuffer[tIndex + 5] += sB * nw;
                } else if (crossY && !crossX) { // cross on Y only
                    w = wy * scale;
                    // add weighted component for current px
                    tBuffer[tIndex] += sR * w;
                    tBuffer[tIndex + 1] += sG * w;
                    tBuffer[tIndex + 2] += sB * w;
                    // add weighted component for next (tY+1) px
                    nw = nwy * scale;
                    tBuffer[tIndex + 3 * tw] += sR * nw;
                    tBuffer[tIndex + 3 * tw + 1] += sG * nw;
                    tBuffer[tIndex + 3 * tw + 2] += sB * nw;
                } else { // crosses both x and y : four target points involved
                    // add weighted component for current px
                    w = wx * wy;
                    tBuffer[tIndex] += sR * w;
                    tBuffer[tIndex + 1] += sG * w;
                    tBuffer[tIndex + 2] += sB * w;
                    // for tX + 1; tY px
                    nw = nwx * wy;
                    tBuffer[tIndex + 3] += sR * nw;
                    tBuffer[tIndex + 4] += sG * nw;
                    tBuffer[tIndex + 5] += sB * nw;
                    // for tX ; tY + 1 px
                    nw = wx * nwy;
                    tBuffer[tIndex + 3 * tw] += sR * nw;
                    tBuffer[tIndex + 3 * tw + 1] += sG * nw;
                    tBuffer[tIndex + 3 * tw + 2] += sB * nw;
                    // for tX + 1 ; tY +1 px
                    nw = nwx * nwy;
                    tBuffer[tIndex + 3 * tw + 3] += sR * nw;
                    tBuffer[tIndex + 3 * tw + 4] += sG * nw;
                    tBuffer[tIndex + 3 * tw + 5] += sB * nw;
                }
            } // end for sx
        } // end for sy

        // create result canvas
        let resCV = document.createElement('canvas');
        resCV.width = tw;
        resCV.height = th;
        let resCtx = resCV.getContext('2d');
        let imgRes = resCtx.getImageData(0, 0, tw, th);
        let tByteBuffer = imgRes.data;
        // convert float32 array into a UInt8Clamped Array
        let pxIndex = 0; //
        for (sIndex = 0, tIndex = 0; pxIndex < tw * th; sIndex += 3, tIndex += 4, pxIndex++) {
            tByteBuffer[tIndex] = Math.ceil(tBuffer[sIndex]);
            tByteBuffer[tIndex + 1] = Math.ceil(tBuffer[sIndex + 1]);
            tByteBuffer[tIndex + 2] = Math.ceil(tBuffer[sIndex + 2]);
            tByteBuffer[tIndex + 3] = 255;
        }
        // writing result to canvas.
        resCtx.putImageData(imgRes, 0, 0);
        return resCV;
    }

    function uniqueId() {
        let length = 8;
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');
        let str = '';

        if (!length) {
            length = Math.floor(Math.random() * chars.length);
        }

        for (let i = 0; i < length; i++) {
            str += chars[Math.floor(Math.random() * chars.length)];
        }

        return str;
    }

    class FileUploadViewModel {
        constructor(params) {
            this.value = params.value;
            this.default = params.default;
            this.hasError = ko.observable(false);
            this.image = ko.observable(ko.unwrap(this.value) || params.default);
            this.width = params.width || 200;
            this.height = params.height || 200;
            this.hasFile = ko.observable(!!ko.unwrap(this.value));
            this.id = uniqueId();
            this.image.subscribe(val => {
                if (val === params.default) {
                    this.value(null);
                } else {
                    this.value(val);
                }
            });
            $(() => {
                let self = this;
                $('#' + this.id).on('change', 'input[type=file]', function() {
                    self.readFile(this);
                });
            });
        }

        readFile(input) {
            try {
                if (input.files && input.files[0]) {
                    if (input.files[0].type.split('/')[0] !== 'image') {
                        this.cancel();
                        this.hasError(true);
                    } else {
                        let reader = new FileReader();

                        reader.onload = e => {
                            let image = new Image();
                            image.src = e.target.result;
                            let self = this;
                            image.onload = function() {
                                let resize = imageToDataUri(this, self.width, self.height, 1.0);
                                self.image(resize);
                                self.hasFile(true);
                                self.hasError(false);
                            };
                        };

                        reader.readAsDataURL(input.files[0]);
                    }
                }
            } catch (e) {
                this.cancel();
                this.hasError(true);
            }
        }

        cancel() {
            $('#' + this.id + ' input[type=file]').val(null);
            this.image(this.default);
            this.hasFile(false);
        }

        upload() {
            $('#' + this.id + ' input[type=file]').click();
        }
    }

    ko.components.register('fileupload', {
        viewModel: FileUploadViewModel,
        template:
            `<div class="fileUploadContainer" data-bind="attr: { id: id }, css: { success: hasFile, error: hasError }">
                <div class="fileUploadImageContainer" data-bind="click: upload">
                    <img class="fileUploadInnerImage" data-bind="attr: { src: image }" />
                    <a class="fileUploadChangeButton" href="#"><i class="fa fa-camera"></i> Change</a>
                </div>
                <input type="file" />
                <a class="fileUploadCancelButton" href="#" data-bind="click: cancel, visible: hasFile"><i class="fa fa-remove"></i> Reset</a>
            </div>`
    });
})();


// WEBPACK FOOTER //
// ./resources/scripts/components/ko.fileUpload.js